module.exports = __webpack_public_path__ + "static/img/xray_1.82d2cfa8.jpg";